import TicketSolidSVG from "@design-system/ui-icons/vanilla/TicketSolid"
import { createIcon } from "../createIcon"

export const TicketSolidIcon = createIcon(TicketSolidSVG)
